import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BreadcrumbProvider } from './contexts/BreadcrumbContext';
import { TourProvider } from './contexts/TourContext';
import ScrollAwareNavbar from './components/ScrollAwareNavbar';
import Home from './pages/Home';
import Auth from './pages/Auth';
import Plants from './pages/Plants';
import PlantDetail from './pages/PlantDetail';
import MyGarden from './pages/MyGarden';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Profile from './pages/Profile';
import Collections from './pages/Collections';
import CollectionDetail from './pages/CollectionDetail';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import TutorialsHome from './pages/Tutorials/TutorialsHome';
import TutorialRouter from './pages/TutorialRouter';
import TutorialsByCategoryPage from './pages/Tutorials/TutorialsByCategoryPage';
import About from './pages/About';
import OurStory from './pages/OurStory';
import Subscribe from './pages/Subscribe';
import MagicLinkCallback from './pages/MagicLinkCallback';
import ComingSoonGrowBoxLanding from './pages/ComingSoonGrowBoxLanding';
import GenericGrowBoxLanding from './pages/GenericGrowBoxLanding';
import LandingPage1 from './pages/LandingPage1';
import StartGrowingLanding from './pages/landing/StartGrowingLanding';
import QuizLanding from './pages/landing/QuizLanding';
import RealResultsLanding from './pages/landing/RealResultsLanding';
import FallGardenClub from './pages/FallGardenClub';
import Cart from './pages/Cart';
import ExternalRedirect from './pages/ExternalRedirect';
import GardenLayouts from './pages/GardenLayouts';
import GardenLayoutDetail from './pages/GardenLayoutDetail';
import LoginPromptModal from './components/modals/LoginPromptModal';
import TourOverlay from './components/tour/TourOverlay';
import TourPrompt from './components/tour/TourPrompt';
import { useLoginPrompt } from './hooks/useLoginPrompt';
import { useAuth } from './hooks/useAuth';

function AppContent() {
  const { user } = useAuth();
  const { showPrompt, closePrompt } = useLoginPrompt();

  return (
    <BreadcrumbProvider>
      <TourProvider>
        <div className="min-h-screen bg-gray-50">
          <ScrollAwareNavbar />
          {/* Add padding to account for fixed navbar */}
          <main className="pt-16">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/magic-link-callback" element={<MagicLinkCallback />} />
              <Route path="/plants" element={<Plants />} />
              <Route path="/plants/:id" element={<PlantDetail />} />
              <Route path="/my-garden" element={<MyGarden />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:slug" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/collections" element={<Collections />} />
              <Route path="/collections/:slug" element={<CollectionDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/tutorials" element={<TutorialsHome />} />
              <Route path="/tutorials/category/:categorySlug" element={<TutorialsByCategoryPage />} />
              <Route path="/tutorials/:potentialSlug" element={<TutorialRouter />} />
              <Route path="/about" element={<About />} />
              <Route path="/our-story" element={<OurStory />} />
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="/coming-soon" element={<ComingSoonGrowBoxLanding />} />
              <Route path="/grow-boxes" element={<ExternalRedirect url="https://shop.bloomagrows.com" />} />
              <Route path="/grow-box" element={<GenericGrowBoxLanding />} />
              <Route path="/grow" element={<LandingPage1 />} />
              <Route path="/start-growing" element={<StartGrowingLanding />} />
              <Route path="/quiz" element={<QuizLanding />} />
              <Route path="/real-results" element={<RealResultsLanding />} />
              <Route path="/fall-garden-club" element={<FallGardenClub />} />
              <Route path="/layouts" element={<GardenLayouts />} />
              <Route path="/layouts/:slug" element={<GardenLayoutDetail />} />
            </Routes>
          </main>
          <LoginPromptModal isOpen={showPrompt} onClose={closePrompt} />
          <TourOverlay />
          <TourPrompt />
        </div>
      </TourProvider>
    </BreadcrumbProvider>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}